
import { connector } from "../../common/connector";

export const defaultItem = {
    id: 0,
    codigo: "",
    nombres: "",
    apellidos: "",
    celular: "",
    direccion: "",
    monto_adeudado_tramites: 0,
    monto_adeudado_honorarios: 0
}

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FILL':
            return action.payload;

        case 'ADD':
            return [...state, action.payload];

        case 'UPDATE':
            return state.map(it => {
                if(it.id === action.payload.id) { return action.payload; }
                else { return it; }
            });

        case 'REMOVE':
            return state.filter(it => it.id != action.payload);

        case 'ADD_PASO':
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos = [...it.pasos, action.payload];
                }
                return it;
            });

        case 'UPDATE_PASO':
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos.map(p => ((p.id === action.payload.id)? it : p));
                }
                return it;
            });

        case 'REMOVE_PASO':
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos = it.pasos.filter(p => p.id !== it.id);
                }
                return it;
            });

        default: return state;
    }
}

export const getItems = (params) => {
    return connector.get('api/clientes', { params: params });
}

export const createItem = (data) => {
    return connector.post('api/clientes', data);
}

export const updateItem = (data) => {
    return connector.put(`api/clientes/${data.id}`, data)
}

export const deleteItem = (id) => {
    return connector.delete(`api/clientes/${id}`);
}
